import styled from "styled-components";
import foxBg from "./images/fox-bg.png";
import renderbusBg from "./images/renderbus-bg.png";

export const ErrorContainer = styled.div<{ isFox: boolean }>`
  height: 100vh;
  background-image: url(${(p) => (p.isFox ? foxBg : renderbusBg)});
  background-size: 100% 100%;
  padding-left: 132px;
  display: flex;
  align-items: center;
  img {
    width: 45%;
    height: auto;
    position: absolute;
    right: 5.4%;
    z-index: 1;
  }
`;

export const LeftWrapper = styled.div`
  z-index: 2;
  margin-bottom: 76px;
  p {
    font-family: "PingFang SC";
    margin: 0;
  }
  .title {
    font-size: 64px;
    color: #ffffff;
    font-weight: 600;
    line-height: 130px;
  }
  .tip {
    font-size: 48px;
    color: #ffffff;
    font-weight: 600;
    line-height: 67px;
  }
  button {
    width: 144px;
    height: 40px;
    line-height: 40px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    margin-top: 100px;
  }
`;
